import Axios from "../constants/api_management/MyHttpHelperWithToken";

// Fetch auction products
export const fetchAuctionProducts = async (page = 1, pageSize = 10) => {
  const response = await Axios.get(`/products`, {
    params: { page, pageSize, auction: true },
  });
  return response.data;
};

// Submit a bid
export const submitBid = async (productId, amount) => {
  const response = await Axios.post(`/products/${productId}/bids`, {
    amount,
  });
  return response.data;
};

// Add to cart
export const addToCart = async (productId) => {
  const response = await Axios.patch(`/cart`, {
    product: productId,
    quantity: 1,
  });
  return response;
};
